/** @format */

import {ReactNode} from 'react';

import {CELL_HEIGHT} from '../../constants';
import {ColumnType, TableVariant} from '../../types';
import {TableCellMemoized} from '../TableCellMemoized';
import {StyledTableFooterRow} from './styles';

interface Props {
  columns: ColumnType[];
  // Карта `columnId → ReactNode`. Колонки без записи рендерятся пустыми.
  cells: Partial<Record<string, ReactNode>>;
  cellHeight?: number;
  variant?: TableVariant;
}

const TableFooterRow = ({columns, cells, cellHeight = CELL_HEIGHT, variant = 'dark'}: Props) => {
  return (
    <StyledTableFooterRow variant={variant}>
      {columns.map(column => (
        <TableCellMemoized
          key={column.id}
          width={column.size}
          cellHeight={cellHeight}
          tableVariant={variant}
        >
          {cells[column.id] ?? null}
        </TableCellMemoized>
      ))}
    </StyledTableFooterRow>
  );
};

export {TableFooterRow};
